(function ($, window) {

    // on document ready
    $(function () {
        // vars
        var $window = $(window);
        var $toggle = $('.bes-page-footer__headline');
        var tResize;

        // mobile menu toggler
        $toggle.click(function () {
            var $btn = $(this);
            var $column = $btn.closest('.bes-page-footer__column');
            // if shown, hide it
            if ($column.hasClass('is-open')) {
                $column.removeClass('is-open');
            }
            // if hidden, show it
            else {
                $column.addClass('is-open');
            }
        });

        // close all on window resize
        $window.on('resize', function () {
            clearTimeout(tResize);
            tResize = setTimeout(function () {
                var $columns = $('.bes-page-footer__column');
                $columns.each(function () {
                    $(this).removeClass('is-open');
                });
            }, 100);
        });
    });

})(window.jQuery, window);